/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativeyearagoone3Inputs */

const en_relativeyearagoone3 = /** @type {(inputs: Relativeyearagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 year ago`)
};

const pt_relativeyearagoone3 = /** @type {(inputs: Relativeyearagoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há 1 ano`)
};

/**
* | output |
* | --- |
* | "1 year ago" |
*
* @param {Relativeyearagoone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativeyearagoone3 = /** @type {((inputs?: Relativeyearagoone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativeyearagoone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativeyearagoone3(inputs)
	return pt_relativeyearagoone3(inputs)
});
export { relativeyearagoone3 as "relativeYearAgoOne" }